// extracted by mini-css-extract-plugin
export default {"customerAccountsTitle":"LoginTitle_customerAccountsTitle__fNBN+","spinner":"LoginTitle_spinner__S9J7Y"};